export enum DataSourceDefinitionPropertyType {
  Number = 'INT',
  String = 'STRING',
  Html = 'HTML',
  Date = 'DATE',
  Reference = 'REFERENCE',
  Geolocation = 'GEOLOCATION',
  Country = 'COUNTRY',
  Boolean = 'BOOLEAN',
}